import { render, staticRenderFns } from "./PurchaseAgreBlock.vue?vue&type=template&id=3e315efb"
import script from "./PurchaseAgreBlock.vue?vue&type=script&lang=js"
export * from "./PurchaseAgreBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports